import React from 'react';
import ActualizacionMasivaFeeLogistico from "./ActualizacionMasivaFeeLogistico";
import TablaFeeLogistico from "../TablaFeeLogistico";

const ActualizacionMasivaLiquidaciones = () => {
  return (
    <div className="container">
      <div className="row page-titles text-center text-md-start">

        <div className="col-12 mb-4">
          <div className="row mb-2 pb-2">

            <div className="col-12 col-md-auto align-self-center">
              <h4 className="text-themecolor color-rojo-megatone">Actualización Masiva</h4>
            </div>
            
            <div className="col-9 p-0 ps-1 border-2 border-start d-inline-flex">
              <div className="row align-items-center">
                <label>Presione el botón Formato Excel para descargar un excel con el formato correcto, luego completelo y vuelva a importarlo.</label>
              </div>
            </div>

          </div>
        </div>

        <div className="col-12 col-xxl-5">
          <ActualizacionMasivaFeeLogistico />
        </div>

        <div className="col-12 col-xxl-7">
          <div className="row">
            <TablaFeeLogistico />
          </div>
        </div>

      </div>
    </div>
  );
};

export default ActualizacionMasivaLiquidaciones;